gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.image-scroll__container');
  const images = document.querySelectorAll('.image-scroll__slider');
  const bannerContent = document.querySelector('.scroll_legacy__container .banner__content p');

  const totalWidth = container.scrollWidth - window.innerWidth / 2;

  gsap.set(container, {
    x: window.innerWidth,
  });

  gsap.fromTo(
    container,
    {
      x: window.innerWidth,
    },
    {
      x: -totalWidth,
      ease: 'none',
      scrollTrigger: {
        trigger: '.scroll_legacy__container',
        start: '50% 50%',
        end: () => `+=${totalWidth}`,
        scrub: true,
        pin: true,
      },
    }
  );

  gsap.to(bannerContent, {
    opacity: 0,
    ease: 'ease-out',
    scrollTrigger: {
      trigger: '.scroll_legacy__container',
      start: '75% 75%',
      end: () => `+=${totalWidth / 2}`,
      scrub: true,
    },
  });

  images.forEach((element) => {
    gsap.set(element, { opacity: 0, y: '20vh', visibility: 'hidden' });

    const imageContainer = element.closest('.image-scroll__slider');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.fromTo(
              element,
              {
                opacity: 0,
                y: '20vh',
                visibility: 'hidden',
              },
              {
                opacity: 1,
                y: 0,
                visibility: 'visible',
                duration: 1,
                ease: 'ease-out',
                scrollTrigger: {
                  trigger: imageContainer,
                  start: 'top center',
                  end: 'center center',
                  scrub: true,
                  toggleActions: 'play reverse play reverse',
                },
              }
            );

            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null, // Use the viewport as the root
        rootMargin: '0px', // No margin
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    observer.observe(element);
  });

  /* images.forEach((imageElement) => {
    const imageContainer = imageElement.closest('.image-scroll__slider');

    imageElement.classList.add(`image-${index}`);

    gsap.to(imageElement, {
      maxWidth: '100%', // End at 100%
      width: '100%',
      scrollTrigger: {
        trigger: imageContainer,
        start: 'top bottom',
        end: 'center center',
        scrub: true,
        ease: CustomEase.create('', '.22, 0.61, .36, 1'),

        onUpdate: (self) => {
          // Calculate the width and max-width values based on progress
          const widthValue = 150 - 50 * self.progress; // Start at 150% and end at 100%
          imageElement.style.maxWidth = `${widthValue}%`;
          imageElement.style.width = `${widthValue}%`;
        },

        onComplete: () => {
          // Ensure the maxWidth and width are 100% at the end of the animation
          imageElement.style.maxWidth = '100%';
          imageElement.style.width = '100%';
        },
      },
    });
  }); */
});
